import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public (unauthenticated) endpoints are also called from customers' own custom domains, where a
// credentialed cross-origin request would be rejected — they never need the auth cookie anyway.
api.interceptors.request.use((config) => {
  if ((config.url || "").startsWith("/public")) config.withCredentials = false;
  return config;
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

// A scheme-less external URL ("example.com/deal") is *relative* to a browser, not an external
// destination — from a page at /b/<slug> it would navigate to /b/<slug>/example.com/deal instead of
// leaving the site. The backend normalizes this on save (see OfferIn's field_validator in
// backend/server.py), but this also guards any offer row written before that existed.
export const normalizeExternalUrl = (url) => {
  if (!url) return url;
  return /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(url) ? url : `https://${url}`;
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
